import { useEffect, useState } from "react";
import api, { BACKEND } from "@/lib/api";

let _settings = null;
let _promise = null;

export function absUrl(u) { return u ? (u.startsWith("http") ? u : `${BACKEND}${u}`) : ""; }

export function loadSiteSettings() {
  if (_settings) return Promise.resolve(_settings);
  if (!_promise) {
    _promise = api.get("/settings/public")
      .then(({ data }) => { _settings = { logo: absUrl(data.logo_url), images: data.images || {}, texts: data.texts || {}, theme: data.theme || {} }; return _settings; })
      .catch(() => { _promise = null; return { logo: "", images: {}, texts: {}, theme: {} }; });
  }
  return _promise;
}

export function clearSiteLogoCache() { _settings = null; _promise = null; }

export function useSiteLogo() {
  const [logo, setLogo] = useState(_settings?.logo || "");
  useEffect(() => { loadSiteSettings().then((s) => setLogo(s.logo)); }, []);
  return logo;
}

export function useSiteImages() {
  const [images, setImages] = useState(_settings?.images || {});
  useEffect(() => { loadSiteSettings().then((s) => setImages({ ...s.images })); }, []);
  const setImage = (slot, url) => {
    if (_settings) _settings.images = { ..._settings.images, [slot]: url };
    setImages((prev) => ({ ...prev, [slot]: url }));
  };
  return { images, setImage };
}

export function useSiteTexts() {
  const [texts, setTexts] = useState(_settings?.texts || {});
  useEffect(() => { loadSiteSettings().then((s) => setTexts({ ...s.texts })); }, []);
  const setText = (slot, value) => {
    if (_settings) _settings.texts = { ..._settings.texts, [slot]: value };
    setTexts((prev) => ({ ...prev, [slot]: value }));
  };
  return { texts, setText };
}

export function applyAccent(color) {
  if (color) document.documentElement.style.setProperty("--gold", color);
}

export function useSiteTheme() {
  const [theme, setTheme] = useState(_settings?.theme || {});
  useEffect(() => { loadSiteSettings().then((s) => setTheme({ ...s.theme })); }, []);
  const setAccent = (color) => {
    if (_settings) _settings.theme = { ..._settings.theme, accent: color };
    setTheme((prev) => ({ ...prev, accent: color }));
    applyAccent(color);
  };
  return { theme, setAccent };
}
